import Vue from 'vue';

const mutations = {
  MERGE_REGISTRATION_STATE(oldState, newState) {
    Vue.lodash.merge(oldState, newState);
  },
};

export default mutations;
